import styles from './PolicyDescription.module.scss';
import { USER_TERM_URL, POLICY_URL } from 'common/utils';

const PolicyDescription = (): JSX.Element => {
  return (
    <div className={styles.smallPrint}>
      購入すると、
      <br />
      <a
        className={styles.link}
        href={USER_TERM_URL}
        target="_blank"
        rel="noopener"
      >
        利用規約
      </a>
      、
      <a
        className={styles.link}
        href={POLICY_URL}
        target="_blank"
        rel="noopener"
      >
        プライバシーポリシー
      </a>
      に
      <br />
      同意したことになります。
    </div>
  );
};

export default PolicyDescription;
